import './actualRaceAfter.css';

const ActualRaceAfter = () => {
  return (
    <div>

    </div>
  );
};

export default ActualRaceAfter;
